import React from 'react'
import { useTranslation } from 'react-i18next';
import { Box, Button, Divider, Grid, IconButton, Modal, Stack, TextField, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useForm } from '../../../hooks';
import { NumberInput } from '../NumberInput';
import { style } from '../../../helpers/editStyle';
import { DateInput } from '../DateInput';
import { toEnglishDate } from '../../../helpers/dateFormat';
import { unSelectOpportunity } from '../../../store/opportunity/opportunitySlice';
import { createAllDivest } from '../../helpers/divestment';

export const DivestAll = ({ setHidden, setReloadData }) => {

    const { t } = useTranslation('global');
    const date = new Date();
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    const actualDate = date.toLocaleDateString("es-ES", options);
    const { dataToAction } = useSelector(state => state.opportunity)

    const dispatch = useDispatch();
    const [formValues, handleInputChange, reset] = useForm({ divestmentDate: toEnglishDate(actualDate), percentageShare: '', salesPrice: '' });

    const { divestmentDate, percentageShare, salesPrice } = formValues;

    const handleCancel = () => {
        reset()
        dispatch(unSelectOpportunity())
        setHidden(false)
    }
    const onSubmit = async (e) => {
        e.preventDefault();
        setHidden(false)
        await createAllDivest({ divestmentDate, percentageShare, salesPrice, opportunityId: dataToAction.id}, t('divestment.successAllCreateMsg'), t('divestment.errorMsg'))
        setReloadData(prevState => !prevState)
    }

    return (
        <Modal
            open={true}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ zIndex: 9999 }}
        >
            <Box sx={style}>
                <Stack direction='row' justifyContent='space-between' alignItems='baseline' sx={{ height: '50px' }}>
                    <Typography color='primary' marginBottom='10px' variant='h5' fontWeight={700}>{t('divestment.divestAll')}</Typography>
                    <IconButton color='primary' onClick={handleCancel}>
                        <CloseRoundedIcon />
                    </IconButton>
                </Stack>
                <form onSubmit={onSubmit} style={{ padding: '10px 5px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                    <Stack sx={{ height: 'calc(70vh - 200px)', overflowY: 'auto', paddingBottom: '10px', paddingRight: '20px' }}>

                        <Stack direction='column' width='100%' gap={0}>
                            <DateInput name={divestmentDate} title='divestmentDate' handleInputChange={handleInputChange} translation='divestmentDate' required={true} />
                        </Stack>

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} padding='0 5px'>
                                <Typography variant='overline' color='secondary'>{t(`number.divestmentPercentage`)}</Typography>
                                <TextField
                                    fullWidth
                                    name='percentageShare'
                                    size="small"
                                    variant="outlined"
                                    value={percentageShare}
                                    onChange={handleInputChange}
                                    required={true}
                                    type='number'
                                    InputProps={{ inputProps: { min: 0, step: 'any', max: 100 } }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} padding='0 5px'>
                                <NumberInput translation='salesPrice' name={salesPrice} title='salesPrice' handleInputChange={handleInputChange} required={true} />
                            </Grid>
                        </Grid>

                    </Stack>

                    <Stack sx={{ heigth: '80px' }}>
                        <Divider sx={{ margin: '30px 0px 15px 0px' }} />

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} md={6} padding='0 5px'>
                                <Button fullWidth onClick={handleCancel} variant="text">{t("createPassword.cancelButton")}</Button>
                            </Grid>
                            <Grid item xs={12} md={6} padding='0 5px'>
                                <Button fullWidth type='submit' variant="contained">{t("createPassword.principalButton")}</Button>
                            </Grid>
                        </Grid>
                    </Stack>
                </form>

            </Box>
        </Modal>
    )
}